import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { SelectList } from "@common/selectList";
import { Sorts } from "../../types";
import { ArrowIcon } from "./arrowIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Sort({ sort: selectedSort, setSort }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.sort}>
      <h3 className={styles.title}>{t("kanban.filters.sortFilter.title")}</h3>
      <SelectList
        rootClassName={styles.rootClassName}
        listClassName={styles.listRoot}
      >
        {({ isOpen, select }) => ({
          input: (
            <div
              className={classNames(styles.input, {
                [styles.openedInput]: isOpen,
              })}
            >
              <p className={styles.title}>{t(selectedSort)}</p>
              <ArrowIcon
                className={classNames(styles.icon, {
                  [styles.iconOpen]: isOpen,
                })}
              />
            </div>
          ),
          list: (
            <ul className={styles.list}>
              {Object.values(Sorts).map((sort) => (
                <li
                  key={sort}
                  onClick={() => select(setSort(sort))}
                  className={classNames(styles.item, {
                    [styles.selected]: selectedSort === sort,
                  })}
                >
                  <p>{t(sort)}</p>
                </li>
              ))}
            </ul>
          ),
        })}
      </SelectList>
    </div>
  );
}

export { Sort };
